import React, { Component } from "react"
import moment from 'moment'

class SearchTable extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            searchResult:[]
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.tablesearch !== this.state.searchResult) {

            this.setState({
                searchResult: nextProps.tablesearch
            })
        }
    }

    render() {

        const { searchResult } = this.state

        return (
            <div className="row no-gutters sp-table-content " style={{ minWidth: '2500px' }}>
                <table className="sp-table table">
                    <thead>
                        <tr className="sp-table-header">

                            <th style={{ width: '150px' }}>
                                <div className="th-text">RRS Doc No.</div>
                            </th>
                            <th style={{ width: '150px' }}>
                                <div className="th-text">PO/Contract No.</div>
                            </th>
                            <th>
                                <div className="th-text">Header Text</div>
                            </th>
                            <th style={{ width: '230px' }}>
                                <div className="th-text">Vendor Name</div>
                            </th>
                            <th style={{ width: '150px' }}>
                                <div className="th-text">สถานะ</div>
                            </th>
                            <th style={{ width: '230px' }}>
                                <div className="th-text">วิธีการจัดหา</div>
                            </th>
                            <th style={{ width: '150px' }}>
                                <div className="th-text">Ref./Invoice No.</div>
                            </th>
                            <th style={{ width: '180px' }}>
                                <div className="th-text">ผู้สร้าง PO/Contract</div>
                            </th>
                            <th style={{ width: '180px' }}>
                                <div className="th-text">Goods Recipient</div>
                            </th>
                            <th style={{ width: '180px' }}>
                                <div className="th-text">พนักงานจัดหาผู้รับผิดชอบ<br/>PO/Contract</div>
                            </th>
                            <th style={{ width: '180px' }}>
                                <div className="th-text">Posting Date</div>
                            </th>
                            <th style={{ width: '180px' }} >
                                <div className="th-text">Reference/<br/>Invoice Date</div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            searchResult ? (
                                searchResult.map((task, index) => (
                                    <tr key={index} >
                                        <td style={{ textAlign: 'center' }}>{task.doc_no}</td>
                                        <td style={{ textAlign: 'center' }}>{task.po_contract_no}</td>
                                        <td style={{ "whiteSpace": "nowrap" }}>{task.po_header_text}</td>
                                        <td>{task.vendor_name}</td>
                                        <td>{task.status_name}</td>
                                        <td>{task.method}</td>
                                        <td>{'Ref./Invoice No'}</td>
                                        <td>{task.createby}</td>
                                        <td>{task.goods_receipe}</td>
                                        <td>{task.create_po_contract_emp_name}</td>
                                        <td style={{ textAlign: 'center' }}>{moment(task.posting_date).format('DD/MM/YYYY')}</td>
                                        <td style={{ textAlign: 'center' }}>{moment(task.po_date).format('DD/MM/YYYY')}</td>
                                       
                                    </tr>
                                ))
                            ) : (
                                    <tr key={0}>
                                        <td colSpan="8" style={{
                                            textAlign: 'center',
                                            fontStyle: 'italic',
                                            color: 'gray'
                                        }}>
                                            No data.
                                        </td>
                                    </tr>
                                )
                        }

                    </tbody>
                </table>
            </div>
        )
    }
}

export default SearchTable